import { ReadonlyURLSearchParams } from "next/navigation";

import { Params } from "~/constants/request";
import { getQueryString } from "~/helpers/get-query-string";

export interface IPaginationUrls {
  prev?: string;
  next: string;
}

export const getPaginationUrls = ({
  nextPage,
  prevPage,
  pathname,
  searchParams,
}: {
  nextPage?: number;
  prevPage?: number;
  pathname?: string;
  searchParams: ReadonlyURLSearchParams;
}): IPaginationUrls => {
  const page = searchParams.get("page");
  const queryWithNoPageAndSlug = Object.fromEntries(searchParams);
  delete queryWithNoPageAndSlug["page"];
  delete queryWithNoPageAndSlug["slug"];
  const currentPage = Number(page) || 1;

  prevPage = prevPage || currentPage - 1;
  nextPage = nextPage || currentPage + 1;

  const prevPageQuery =
    prevPage > 1
      ? {
          ...queryWithNoPageAndSlug,
          [Params.PAGE]: JSON.stringify(prevPage),
        }
      : { ...queryWithNoPageAndSlug };

  const nextPageQuery = {
    ...queryWithNoPageAndSlug,
    [Params.PAGE]: JSON.stringify(nextPage),
  };

  const prevPageQueryString = getQueryString(prevPageQuery);
  const nextPageQueryString = getQueryString(nextPageQuery);

  let path,
    hash = "";

  if (typeof location !== "undefined") {
    // client side rendering
    path = location.pathname;
    hash = location.hash || "";
  } else {
    // server side rendering
    path = `${pathname?.split("?")[0]}`;
    hash = "";
  }

  const combineUrl = (query: string): string =>
    `${path}${query ? `?${query}` : ""}${hash}`;

  return {
    ...(prevPage > 0 && { prev: combineUrl(prevPageQueryString) }),
    next: combineUrl(nextPageQueryString),
  };
};
